module.exports = __webpack_public_path__ + "img/hero-image.163a28c9.jpg";